export const AI_CENTER_MODULES = [
  { key: "risk", title: "AI Property Risk Score", badge: "Live" },
  { key: "review", title: "AI Legal-Safe Review Assistant", badge: "Live" },
  { key: "scam", title: "AI Scam Detector", badge: "Live" },
  { key: "maintenance", title: "AI Maintenance Analyzer", badge: "Live" },
  { key: "lease", title: "AI Lease Explainer", badge: "Live" },
  { key: "neighborhood", title: "AI Neighborhood Intelligence", badge: "Live" },
  { key: "reputation", title: "AI Reputation Timeline", badge: "Live" },
  { key: "matching", title: "AI Smart Matching", badge: "Early Access" },
  { key: "move", title: "AI Move-In Assistant", badge: "Live" },
  { key: "rent", title: "AI Market Rent Estimator", badge: "Early Access" },
  { key: "leaseAnalyzer", title: "AI Lease Analyzer", badge: "Live" },
  { key: "inspection", title: "AI Move-In Inspection Assistant", badge: "Live" },
  { key: "landlordResponse", title: "AI Landlord Response Assistant", badge: "Live" },
  { key: "pmCopilot", title: "AI Property Manager Copilot", badge: "Live" },
  { key: "marketInsights", title: "AI Rental Market Insights", badge: "Early Access" },
  { key: "moveOutDispute", title: "AI Move-Out Dispute Assistant", badge: "Live" },
];

export const AI_CENTER_DISCLAIMER = "RentDuo AI guidance is informational only and is not legal, financial, housing, or professional advice.";

export function aiRiskTone(level = "") {
  const normalized = String(level || "").toLowerCase();
  if (normalized === "high") return "danger";
  if (normalized === "moderate" || normalized === "medium") return "warning";
  return "success";
}

export function prettyAiLabel(value = "") {
  return String(value || "").replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
